// Helper functions from CompactPatientCard
const getAge = (index) => {
  if (index === 0) return 27;  // First patient is young
  if (index === 1) return 45;  // Second patient is middle-aged
  if (index === 2) return 66;  // Third patient is middle-aged
  return 60 + ((index * 7) % 21);  // Will generate ages between 60-80
};

const getSurgeryDateTime = (index) => {
  if (index < 3) return { date: 'March 10, 2025', time: ['08:00', '11:00', '13:00'][index] };
  if (index < 6) return { date: '3/11/25', time: ['08:00', '11:00', '14:00'][index - 3] };
  return { date: '3/12/25', time: ['08:00', '12:00', '14:00', '16:00'][index - 6] };
};

const procedures = [
  'Laminectomy L4/L5',
  'Fusion C6/C7',
  'Laminectomy L4/L5',
  'Discectomy L5/S1',
  'Fusion C5/C6',
  'Fusion T3/T4',
  'Laminectomy L4/L5',
  'Discectomy C5/C6',
  'Laminectomy L4/L5',
  'Laminectomy C1/C2'
];

// Generate 10 patient records
export const patients = [...Array(10)].map((_, index) => {
  const surgery = getSurgeryDateTime(index);
  return {
    id: index + 1,
    name: `John Doe ${index + 1}`,
    age: getAge(index),
    procedure: procedures[index],
    surgeryDate: surgery.date,
    surgeryTime: surgery.time,
    status: 'pending', // 'pending', 'approved', or 'denied'
    riskFactors: [
      index > 5 ? 'Age over 65 (High Risk)' : 'Age under 65 (Low Risk)',
      'Current Pradaxa Treatment',
      'Spinal Surgery Location'
    ]
  };
}); 